type WebState = {
  isCartOpen: boolean
}

export const useWebsiteStore = defineStore('webStore', {
  state: (): WebState => ({
    isCartOpen: false
  }),
  actions: {
    //   async fetch() {
    //     const infos = await $fetch('https://api.nuxt.com/modules/pinia')
    //     this.name = infos.name
    //     this.description = infos.description
    //   }
    openCart() {
      this.isCartOpen = true
    },
    closeCart() {
      this.isCartOpen = false
    }
  }
})
